import {$} from 'uikit-util';

export default {

    props: {
        container: Boolean
    },

    data: {
        container: true
    },

    computed: {

        container({container}) {
            return container === true && this.$container || container && $(container);
        }

    }

};



//////////////////
// WEBPACK FOOTER
// ./public/themes/frontend/museo/node_modules/uikit/src/js/mixin/container.js
// module id = null
// module chunks = 